exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-component[data-v-38807b20]{resize:none!important;overflow:auto;border-color:#dedede;border-radius:5px;max-height:43px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-38807b20&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/filter/SearchComponent.vue
// module id = 871
// module chunks = 2